type Row = { [key: string]: unknown };

/** True for a row whose result status is Fail or Alert (the numeric 2 is the legacy Fail code). */
export function isFailOrAlertRow(element: Row): boolean {
  const status = (element as { resultStatus?: unknown })?.resultStatus;
  if (typeof status === 'string') {
    return status.trim().toLowerCase() === 'fail' || status.trim().toLowerCase() === 'alert';
  }
  if (typeof status === 'number') {
    return status === 2;
  }
  return false;
}

export function isDiscardedRow(element: Row): boolean {
  const status = (element as { isDiscarded?: unknown })?.isDiscarded;
  return typeof status === 'boolean' ? status : false;
}

/** True for a replicate excluded from the mean as an outlier (shaded like a discard, but not one). */
export function isOutlierRow(element: Row): boolean {
  const flag = (element as { isOutlier?: unknown })?.isOutlier;
  return typeof flag === 'boolean' ? flag : false;
}

/** The rows the "Failures & Discards Only" filter keeps. */
export function isFailedOrDiscardedRow(element: Row): boolean {
  return isFailOrAlertRow(element) || isDiscardedRow(element);
}
